import * as React from 'react'

export function ActionsCell({ row }) {
  const request = row.original
  return (
    <a href={request.url} target="_blank" rel="noopener noreferrer">
      View
    </a>
  )
}
